import { render, staticRenderFns } from "./Abutting.vue?vue&type=template&id=61ec1a0a&scoped=true&"
import script from "./Abutting.vue?vue&type=script&lang=js&"
export * from "./Abutting.vue?vue&type=script&lang=js&"
import style0 from "./Abutting.vue?vue&type=style&index=0&id=61ec1a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec1a0a",
  null
  
)

export default component.exports